import { useFormContext, useWatch } from 'react-hook-form';
import { SignInputSchool, SignInputSchoolManual } from '@/module/auth/sign-up';
import { type StudentEditFormData } from '../schema';
import { CommonEditForm } from './CommonEditForm';
export const StudentEditForm = () => {
  const {
    control
  } = useFormContext<StudentEditFormData>();
  const countryCode = useWatch({
    control,
    name: 'countryCode'
  });
  const isKR = countryCode === 'KR';
  return <>
      <CommonEditForm data-sentry-element="CommonEditForm" data-sentry-source-file="StudentEditForm.tsx" />
      {isKR ? <SignInputSchool /> : <SignInputSchoolManual />}
    </>;
};